<template>
    <div id="product-configurator" :class="product != null && product.Product != null && product.Product.ProductType == 2 && partnumbersByColor != undefined && partnumbersByColor.length == 1 ? 'one-size' : ''" v-if="product && product.ShowProductSelector == true">
        <V12 :V12Label="product.V12Label" :V12FinanceProducts="product.V12FinanceProducts" :Product="product" :Amount="partnumber != null ? partnumber.price : product.Partnumbers[0].price" v-if="product.V12FinanceProducts != undefined && product.V12FinanceProducts.length > 0"></V12>

        <!--Addons Description when available-->
        <p id="bundlesIntro" v-if="bundles && bundles.length > 0 && getInterfaceText('shop_bundles_intro').length > 0" v-html="getInterfaceText('shop_bundles_intro')"></p>

        <div class="wrapper">
            <!-- 2 or more colors: circles-->
            <!--<template v-if="product.ColorCodes && product.ColorCodes.length > 1 && hasUsage == false">-->
            <template v-if="product.ColorCodes && product.ColorCodes.length > 1 && (hasUsage == false || hasDifferentSizes == true)">
                <!--WDR 20230309: Indien Partnumber.Usage waardes heeft dan Colour waardes negeren. -->
                <p class="subheading">
                    <span class="headinglabel" role="heading" aria-level="3">{{getInterfaceText('shop_color')}}</span>
                    <span class="headingvalue" v-show="color.length > 0"> - <strong>{{color}}</strong></span>
                    <span class="headinglabel" v-if="partnumber != null && product.PriceDifferences"> ({{partnumber.priceToFormat}})</span>
                </p>
                <div class="colors">
                    <template v-for="item in product.ColorCodes" :key="item.Description">
                        <input type="radio" name="color" :value="item.Description" :id="'radio' + item.Description" v-model="color" v-on:click="selectColor(item)" />
                        <label :for="'radio' + item.Description" :class="color == item.Description ? 'selected' : ''" :title="item.Description">
                            <i class="icongiant-check"></i>
                            <span class="circle-border">
                                <span class="circle" :style="{ backgroundColor: '#'+item.HexCodePrimary }"></span>
                                <span :v-if="item.HexCodePrimary" class="halfcircle" :style="{ backgroundColor: '#'+item.HexCodeSecondary }"></span>
                            </span>
                            <!--<span class="text">{{item.Description}}</span>-->
                        </label>
                    </template>
                </div>
            </template>
            <template v-else-if="hasUsage == true && (product.Partnumbers.length > 1 || partnumbersByColor[0].size.length > 0)">
                <p class="subheading">
                    <span class="headinglabel" role="heading" aria-level="3">{{getInterfaceText('shop_selectyourversion')}}</span>
                    <span class="headingvalue" v-if="partnumber != null"> - <strong>{{partnumber.description}}</strong></span>
                </p>
            </template>

            <!--e-commerce block-->
            <div>
                <!-- size blocks with extra info and dealers -->
                <div :class="(product.StoreSaleProduct == null ? 'sizes' : '')" v-show="product.Product != null && product.Partnumbers != null && product.Partnumbers.length > 0 && partnumbersByColor.length > 0 && (product.Partnumbers.length > 1 || partnumbersByColor[0].size.length > 0) && (hasSizes == true || hasUsage == true)">
                    <p class="subheading" v-show="hasUsage == false && viewmode != 'axapta'">
                        <span v-if="product.StoreSaleProduct == null">
                            <span class="headinglabel" role="heading" aria-level="3" v-if="partnumber != null && partnumber.code.length > 0">{{getInterfaceText('shop_size')}}</span>
                            <span class="headinglabel" role="heading" aria-level="3" v-else>{{getInterfaceText('shop_size_choose')}}</span>
                            <span class="headingvalue" v-if="partnumber != null && partnumber.code.length > 0"> - <strong>{{partnumber.description}}</strong></span>
                        </span>
                        <span v-else>
                            <span class="headinglabel">&nbsp;</span>
                        </span>
                        <!-- whatismysize - different versions -->
                        <span class="whatismysize-wrapper" v-show="(product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0) || product.Product.GearSizingPageId || product.Product.HasFrameSizes || product.SmartfitAvailable || product.EyeFitUAvailable">
                            <span class="whatismysize" v-if="showBikeAdvancedSizingTool">
                                <a href="#" v-on:click="trackEventBikeAdvancedSizingTool" data-toggle="modal" data-target="#advancedSizingToolModal">{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.SmartfitAvailable">
                                <!-- Smart Fit V2 -->
                                <a href="javascript:void(0);"
                                   id="custom-oz-button"
                                   class="oz-trigger"
                                   :data-oz-code="product.Partnumbers[0].barcode"
                                   :data-oz-name="product.Product.Name"
                                   :data-oz-image="(product.Product.CloudinaryImagesToPartnumbers.length > 0 ? product.Product.CloudinaryImagesToPartnumbers[0].CloudinaryImage.ImageUrlMain : '')"
                                   data-oz-fullscreen="true"
                                   onclick="trackEventGlobalAndLocal('Size', 'Standard', 'SmartFit');"
                                   data-oz-embed="custom"
                                   oz-trigger-id="custom-oz-button">{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.EyeFitUAvailable">
                                <!-- EyeFitU -->
                                <article style="height: 44px"
                                         data-eyefitu-sizing-widget="true"
                                         :data-language="language"
                                         :data-brand="product.EyeFitU.Brand"
                                         :data-product="product.EyeFitU.Title"
                                         :data-image="product.Product.Image"
                                         :data-gender="product.EyeFitU.Gender"
                                         :data-sizes="JSON.stringify(product.Partnumbers.map(a => a.size))"
                                         :data-default-units="measurement == 'Miles' ? 'imperial' : 'metric'"
                                         :data-giant-fit="product.EyeFitU.Fit"
                                         data-flow="giant"
                                         class="notranslate">
                                </article>
                            </span>
                            <span class="whatismysize" v-else-if="product.Product != null && product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0">
                                <a data-fancybox :href="product.Product.SizingSheetUrl" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Sizing sheet');">{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.Product != null && product.Product.GearSizingPageId != undefined && product.Product.GearSizingPageId > 0">
                                <a data-fancybox data-type="iframe" :href="'/'+ countryCode +'/gear/sizingpage/'+ product.Product.GearSizingPageId" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Sizing Page');" style="color: #676767;"><i class="glyphicon glyphicon-question-sign" style="margin-right:5px;"></i>{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.Product != null && product.Product.HasFrameSizes">
                                <a href="#geometry" id="bikeframesize-geometry-tab" class="act-like-tab-click" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Frame sizes');" style="color: #676767;"><i class="glyphicon glyphicon-question-sign" style="margin-right:5px;"></i>{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else>
                                <!--nothing-->
                            </span>
                        </span>
                    </p>

                    <!-- SIZES -->
                    <div class="row-fluid clearfix" v-if="product.StoreSaleProduct == null">
                        <span class="sr-only">Choosing a size may affect availability and Buying Options</span>
                        <template v-for="item in partnumbersByColor" :key="item.code">
                            <!-- SIZE -->
                            <button class="name-and-stockinfo size" :class="item == partnumber ? 'size-selected' : ''" :id="item.code" :aria-current="item == partnumber ? 'true' : 'false'" v-on:click="togglePartnumber(item)">
                                <div class="name">{{item.description}}</div>
                                <span v-if="product.PriceDifferences">&nbsp;({{item.priceToFormat}})</span>
                            </button>
                        </template>
                    </div>
                </div>

                <p class="sizingnote" v-show="product.Product.SizingNote != null">
                    {{product.Product.SizingNote}}
                </p>
                <SelectedPartnumber :setShowDealerSelector="setShowDealerSelector" @update:setShowDealerSelector="setShowDealerSelector = $event"></SelectedPartnumber>
                <SupplementaryItems v-if="partnumber != null && partnumber.code.length > 0 && partnumber.supplementaryGroup != null"></SupplementaryItems>
                <StockContainer :setShowDealerSelector="setShowDealerSelector" @update:setShowDealerSelector="setShowDealerSelector = $event"></StockContainer>
            </div>
        </div>

        <div class="alert alert-danger" v-show="exceptionMessageCart != undefined && exceptionMessageCart.length > 0">{{exceptionMessageCart}}</div>

        <div class="addons" v-if="addOns && addOns.length > 0 && viewmode != 'axapta'">
            <p style="margin:0;"><span style="text-transform: uppercase;font-size:14px;">{{getInterfaceText('shop_choose_add_ons')}}</span></p>
            <template v-for="addon in addOns" :key="addon.Id">

                <div class="item" v-on:mouseover="showAddOnOverlayImage(addon)" v-on:mouseout="hideAddOnOverlayImage(addon)" :class="{ 'item-selected' : hasProductInCart(addon.GearGlobalProductId) }">
                    <div class="text">
                        <h5>
                            {{ addon.Name }}
                            <button class="btn btn-info" v-if="addon.Description" type="button" data-toggle="collapse" :data-target="'#collapseItem'+ addon.Id" aria-expanded="false" aria-controls="'collapseItem'+ addon.Id">i</button>
                        </h5>
                        <div class="collapse extra-info" :id="'collapseItem'+ addon.Id">
                            <div class="padding">
                                {{ addon.Description }}
                            </div>
                        </div>
                        <p style="margin-bottom:0;">
                            {{ addon.PriceToFormat }}
                        </p>
                        <button class="btn btn-add" v-show="hasProductInCart(addon.GearGlobalProductId) == false" v-on:click="addCartItem(addon.PartnumberCode, addon.GearLocalProductId, 2, addon, addon.Partnumber);animateAddOn($event)">{{getInterfaceText('add_to_cart')}}</button>
                        <div class="added" v-show="hasProductInCart(addon.GearGlobalProductId)">
                            <span class="added-text"><i class="icongiant-check" aria-hidden="true"></i> {{getInterfaceText('shop_added_to_cart')}}</span>
                            <button class="btn btn-remove" v-on:click="removePartnumberFromCart(addon.PartnumberCode)" title="Remove from cart"><i class="glyphicon glyphicon-trash"></i></button>
                        </div>
                    </div>
                    <div class="image">
                        <a v-if="addon.CloudinaryImageGearProduct" :href="addon.CloudinaryImageGearProduct.ImageUrlZoom" class="galleryzoom" data-fancybox="gallery"><img :src="addon.CloudinaryImageGearProduct.ImageUrlSmall" /></a>
                    </div>
                </div>
            </template>

        </div>
        <div class="bundles" v-if="bundles && bundles.length > 0 && viewmode != 'axapta'">
            <p style="margin:0;"><span style="text-transform: uppercase;font-size:14px;">{{getInterfaceText('shop_choose_bundles')}}</span></p>
            <p v-if="getInterfaceText('shop_choose_bundles_disclaimer').length > 0" style="font-size: 12px;">{{getInterfaceText('shop_choose_bundles_disclaimer')}}</p>
            <div style="border-top: 1px solid rgb(233, 233, 233); padding-top: 20px;">
                <template v-for="bundle in bundles" :key="bundle">
                    <BundleItem :bundle="bundle" :parentProduct="this.product"></BundleItem>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import vueStore from '../../store/store.js';
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import SelectedPartnumber from '@/components/SelectedPartnumber.vue';
    import BundleItem from '@/components/BundleItem.vue';
    import V12 from '@/components/V12.vue';
    import StockContainer from '@/components/StockContainer.vue';
    import SupplementaryItems from '@/components/SupplementaryItems.vue';

    export default {
        mixins: [cartMixin, generalMixin],
        components: {
            BundleItem,
            V12,
            SelectedPartnumber,
            StockContainer,
            SupplementaryItems
        },
        data: function () {
            return {
                exceptionMessageCart: '',
                isClientSearchFieldEnabled: false,
                isAvailableInTextVisible: true,
                activeDealers: [],
                isNotifyMeVisible: false,
                loadingDealers: true,
                pickupAvailable: false,
                showShippingCostsAtProductSelector: false,
                id: '',
                producttypeid: '',
                culture: window.culture,
                countryId: window.countryId,
                countryCode: window.countryCode,
                partnumberDefault: '',
                setShowDealerSelector: false,
                setShowContact: false,
                addingProductToCart: false,
                enterLocationEnabled: false,
                measurement: window.measurement,
                showBikeAdvancedSizingTool: false,
                language: window.languageCode,
                viewmode: '',
                sellLocalStockStoreSites: false
            }
        },
        methods: {
            async fetchApi() {
                if (this.id > 0) {
                    await axios.get(this.apiUrl)
                        .then((response) => {
                            vueStore.commit('setProduct', response.data)
                            //set default values
                            if (this.partnumberDefault != null && this.partnumberDefault.length > 0) {
                                var partnumber = response.data.Partnumbers?.filter(x => x.code == this.partnumberDefault)
                                if (partnumber.length > 0) {
                                    vueStore.commit('setPartnumber', partnumber[0]);
                                    this.color = partnumber[0].color;
                                }
                            }
                        })
                }
            },
            removeSelectedDealer() {
                vueStore.commit('setDealer', null);
            },
            selectColor(color) {
                // SK add ga4 tracking
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_color', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': color.Description });
            },
            togglePartnumber(partnumber) {
                //reset dealer selector
                this.setShowDealerSelector = false;
                this.setShowContact = false;
                //set partnumber to null if partnumber is already selected (toggle)
                if (this.partnumber != null && this.partnumber.code == partnumber.code) {
                    partnumber = null;
                    this.resetDefaultPartnumber();
                    // commit action to store
                    vueStore.commit('setPartnumber', partnumber);
                    //set default shipping option
                    //this.shippingOption = this.getFirstShippingOptionAvailable();
                } else {
                    this.setPartnumberAndGetDealers(partnumber);
                }
                if (partnumber != null && this.product.HasVariations && this.product.Colors.length <= 1) { //set different image
                    vueStore.state.activeImage = this.cloudinaryImageByPartnumberCode(partnumber.code);
                }
                //track GA
                window.trackEventGlobalAndLocal('Select your size', 'Click', document.title);
                //GA4
                if (partnumber != null && this.product.Partnumbers.length > 1) {
                    window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_size', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': partnumber.description, 'ga4_model_size': partnumber.size, 'ga4_model_color': partnumber.color, 'ga4_model_release_year': this.product.Product.CollectionYear + '', 'ga4_inventory_status': partnumber.stock.Label  });
                }
            },
            setPartnumberAndGetDealers(partnumber) {
                // remove selected dealer
                this.removeSelectedDealer();
                // reset dealer search settings
                this.resetDealerSearch();
                //reset notify me form
                this.isNotifyMeVisible = false;
                // commit action to store
                vueStore.commit('setPartnumber', partnumber);
                //reset required label
                //this.showLabelRequiredPartnumber = false;

                if (partnumber != null && partnumber.stock.Code == 2 && partnumber.stock.ContainsLocalstock == true && partnumber.stock.IsRetailDirectToConsumer == false) {
                    this.setShowDealerSelector = true;
                } else {
                    this.setShowDealerSelector = false;
                }
            },
            resetDealerSearch() {
                this.isWillingToTakeARoadTrip = false;
                this.isDealerSearchFieldEnabled = false;
                this.isDealerListVisible = false;
                this.isLocalStockOnlyMode = true;
            },
            showAddOnOverlayImage(addon) {
                if (!this.hasProductInCart(addon.GearGlobalProductId)) {
                    addon.IsSelected = true;
                }
            },
            hideAddOnOverlayImage(addon) {
                if (!this.hasProductInCart(addon.GearGlobalProductId)) {
                    addon.IsSelected = false;
                }
            },
            hasLocalStockDealers() {
                return (this.dealers?.filter(x => x.Type == 'local').length > 0);
            },
            setClientLocation(item, callback, that, skipCountry) {
                var thisParent = this
                window.getLatLng(item + (skipCountry == true ? '' : ' ' + window.country), function (lat, lng) {
                    if (lat != null) {
                        var clientlocation = { city: item, lat: lat, lng: lng }
                        vueStore.commit('setClientLocation', clientlocation)
                        document.cookie = 'clientLocation=' + JSON.stringify(clientlocation) + '; path=/' + window.culture;
                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else if (skipCountry == true) {
                        //stop trying....
                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else {
                        //try to find without country suffix
                        thisParent.setClientLocation(item, callback, that, true)
                    }
                })
            },
            getClientLocation() {
                var clientLocation = window.readCookie('clientLocation')
                if (clientLocation != null) {
                    try {
                        vueStore.commit('setClientLocation', JSON.parse(clientLocation))
                    } catch (e) {
                        console.log(e);
                    }
                }
            },
            toggleNotifyMeForm() {
                this.isNotifyMeVisible = !this.isNotifyMeVisible;
                //track GA
                window.trackEventGlobalAndLocal('Notify me when available', 'Click', document.title);
            },
            cloudinaryImageByPartnumberCode(partnumberCode) {
                for (var i = 0; i < this.product.Product.CloudinaryImagesToPartnumbers.length; i++) {
                    for (var j = 0; j < this.product.Product.CloudinaryImagesToPartnumbers[i].PartnumberCodes.length; j++) {
                        if (this.product.Product.CloudinaryImagesToPartnumbers[i].PartnumberCodes[j] == partnumberCode) {
                            return this.product.Product.CloudinaryImagesToPartnumbers[i];
                        }
                    }
                }
            },
            toggleEnterLocation() {
                this.enterLocationEnabled = !this.enterLocationEnabled;
            },
            trackEventBikeAdvancedSizingTool() {
                // old tracking
                window.trackEventGlobalAndLocal('Bike sizing tool', 'Click', 'Initialize tool - ' + this.product.Product.Name)
                // SK add ga4 tracking
                var clickText = this.getInterfaceText('shop_whatismysize');
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'what_is_my_size', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': clickText });
            },
            resetDefaultPartnumber() {
                this.partnumberDefault = null;
            }
        },
        computed: {
            partnumber() {
                return vueStore.state.partnumber
            },
            selectedDealer() {
                return vueStore.state.dealer
            },
            apiUrl() {
                return '/' + window.culture + '/shop/productselector/' + this.id + '/' + this.producttypeid + '/true'
            },
            product() {
                return vueStore.state.product
            },
            color: {
                get() {
                    return vueStore.state.color
                },
                set(value) {
                    vueStore.commit('setColor', value)
                }
            },
            partnumbersByColor() {
                var partnumbers = [];
                //GDG 20240116: op usage uitgezet ivm alle maten die getoond werden voor https://test.giant-bicycles.com/us/maxxis-minion-dhf-2023
                if (this.hasUsage && this.hasDifferentSizes == false) {
                    partnumbers = this.product.Partnumbers;
                } else {
                    partnumbers = this.product.Partnumbers?.filter(x => x.color == this.color);
                }
                if (partnumbers.length == 0) {
                    //voor uitzonderingen als een product een usage heeft of zoals CONTACT SLR AEROLIGHT STEM alle partnumbers tonen
                    partnumbers = this.product.Partnumbers;
                }
                //set default partnumber if it's only 1 partnumber
                if (partnumbers != null && partnumbers.length == 1) {
                    this.setPartnumberAndGetDealers(partnumbers[0]);
                }
                //set default partnumber it's in querystring
                if (this.partnumber == null && this.partnumberDefault != null) {
                    var partnumber = this.product.Partnumbers?.filter(x => x.code == this.partnumberDefault)[0];
                    this.setPartnumberAndGetDealers(partnumber);
                    this.resetDefaultPartnumber();
                }
                return partnumbers;
            },
            GAclientId() {
                var ga_clientId;
                try {
                    if (window.ga.getAll()[0].get('clientId') != undefined) {
                        ga_clientId = window.ga.getAll()[0].get('clientId');
                    }
                } catch (e) {
                    //do nothing
                }
                return ga_clientId;
            },
            sellLocalStock() {
                return this.product.SellLocalStock;
            },
            //isNotifyMe() {
            //    return this.isSellable == false && this.product.Partnumbers?.filter(x => x.notifyMe == true).length > 0
            //},
            hasUsage() {
                return this.product.Partnumbers?.filter(x => x.hasUsage == true).length > 0
            },
            hasSizes() {
                return this.product.Partnumbers?.filter(x => x.size != null && x.size.length > 0).length > 0
            },
            hasDifferentSizes() {
                var _size = '';
                if (this.product.Partnumbers?.filter(x => x.size.length > 0).length > 0) {
                    for (var i = 0; i < this.product.Partnumbers.length; i++) {
                        if (this.product.Partnumbers[i].size != '' && this.product.Partnumbers[i].size != _size) {
                            if (_size.length > 0) {
                                return true;
                            } else {
                                _size = this.product.Partnumbers[i].size;
                            }
                        }
                    }
                }
                return false;
            },
            localstockDealers() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'local');
                } else {
                    return [];
                }
            },
            warehouseAndlocalstockDealersWithinRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.IsDealerWithinRadius);
                } else {
                    return [];
                }
            },
            clientLocation() {
                return vueStore.state.clientLocation
            },
            addOns() {
                return this.product.Product?.AddOns;
            },
            bundles() {
                return this.product.BundleItems;
            },
            showDealerSelector() {
                return this.partnumber.stock.IsRetailDirectToConsumer == false || this.setShowDealerSelector == true;
            },
            isRetailDirectToConsumer() {
                return this.partnumber != null && this.partnumber.stock != null && (this.partnumber.stock.IsRetailDirectToConsumer || this.product.DirectshipmentAvailableGear == true && this.partnumber.stock.Code == 1);
            },
            productId() {
                return vueStore.state.productId;
            }
        },
        beforeMount() {
            this.fetchApi()
        },
        watch: {
           
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            this.pickupAvailable = document.getElementById('vue-product-selector-v2').dataset.pickupavailable == 'true';
            this.showShippingCostsAtProductSelector = document.getElementById('vue-product-selector-v2').dataset.showshippingcostsatproductselector == 'true';
            this.id = document.getElementById('vue-product-selector-v2').dataset.productid;
            this.producttypeid = document.getElementById('vue-product-selector-v2').dataset.producttypeid;
            this.partnumberDefault = window.getParameterByName('partnumber'); //document.getElementById('vue-product-selector-v2').dataset.partnumberdefault;
            this.showBikeAdvancedSizingTool = document.getElementById('vue-product-selector-v2').dataset.showbikeadvancedsizingtool == 'true';
            //this.displayInstockLabelAsInfoIconPopout = document.getElementById('vue-product-selector-v2').dataset.displayinstocklabelasinfoiconpopout == 'true';
            this.viewmode = document.getElementById('vue-parameters').dataset.viewmode;
            /*this.sellLocalStockStoreSites = document.getElementById('vue-product-selector-v2').dataset.selllocalstockstoresites == 'true';*/
        },
        mounted() {
            window.loadExternalScript('https://web-sdk.eyefitu.com/v1/sdk/init.js', function () {
                if (!window.eyefitu) {
                    window.eyefituCalls = [];
                    window.eyefitu = function () { window.eyefituCalls.push(arguments) };
                }
                window.eyefitu('store', 'www.giant.com');
                window.eyefitu('init');
            });
        }
    }
</script>
